// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { locationSearchFormStyles } from "@stoneage/Overrides/Components/LocationSearchForm";
import { xScreen } from "@stoneage/XDL/Utilities";
import { css } from "styled-components";

locationSearchFormStyles.searchContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        ${({ doesSalesRepExist }: any) =>
            doesSalesRepExist
                ? css`
                      height: calc(644px - var(--rep-container-height));
                  `
                : css`
                      height: 644px;
                  `};
        ${xScreen("lte", "md")} {
            ${({ doesSalesRepExist }: any) =>
                doesSalesRepExist
                    ? css`
                          height: calc(644px - var(--rep-container-height));
                      `
                    : css`
                          height: 405px;
                      `};
        }
    `,
};

locationSearchFormStyles.centeringWrapper = {
    css: css`
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 300px;
    `,
};

locationSearchFormStyles.modal = {
    size: 400,
    cssOverrides: {
        modalBody: css`
            ${xScreen("lte", "md")} {
                max-width: 400px;
            }
        `,
    },
};
